import actionCreatorFactory from "typescript-fsa";
import api from "../api";
import { State } from "../state";

import { isCreditLensFeatureEnabled } from "src/configState/selector";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import { getSpreadId } from "../spread/model/spread/selector";
import { Comment } from "./types";

const create = actionCreatorFactory("Comments");
const createAsync = asyncFactory<State>(create);

export interface AddCommentParams {
  commentText: string;
  username: string;
  spreadId: string;
  accountId?: string;
  accountName?: string;
  period?: string;
}

interface AddCommentSuccessParams {
  comment: Comment;
  version: number;
}

export const addComment = createAsync<
  AddCommentParams,
  AddCommentSuccessParams
>("ADD_COMMENT", async (params, dispatch, getState) => {
  return await api.comments.addComment(
    params.commentText,
    params.spreadId,
    isCreditLensFeatureEnabled(getState()),
    params.accountId,
    params.accountName,
    params.period
  );
});

export const getComments = createAsync<string, Comment[]>(
  "GET_COMMENTS",
  async (spreadId, dispatch, getState) => {
    return (
      (await api.comments.getComments(
        spreadId,
        isCreditLensFeatureEnabled(getState())
      )) || []
    );
  }
);

export interface AddUserToReadByForBriefspreadParams {
  spreadId: string;
}

interface AddUserToReadByForBriefspreadSuccess {
  version: number;
}

export const addUserToReadByForBriefspread = createAsync<
  AddUserToReadByForBriefspreadParams,
  AddUserToReadByForBriefspreadSuccess
>("ADD_USER_TO_READ_BY_FOR_BRIEF_SPREAD", async params => {
  return await api.comments.addUserToReadByForBriefspread(params.spreadId);
});

export interface AddUserToReadByForCommentsParams {
  comments: Comment[];
  userId: string;
}

export interface AddUserToReadByForCommentsSuccess {
  comments: Comment[];
  userId: string;
  result: boolean;
}

export const addUserToReadByForComments = createAsync<
  AddUserToReadByForCommentsParams,
  AddUserToReadByForCommentsSuccess
>("ADD_USER_TO_READ_BY_FOR_COMMENTS", async (params, dispatch, getState) => {
  const spreadId = getSpreadId(getState());
  const result = await api.comments.addUserToReadByForComments(
    params.comments,
    isCreditLensFeatureEnabled(getState()),
    spreadId
  );

  return { result, comments: params.comments, userId: params.userId };
});

const addCommentAction = thunkToAction(addComment.action);
export type AddCommentActionType = typeof addCommentAction;

const getCommentsAction = thunkToAction(getComments.action);
export type GetCommentsActionType = typeof getCommentsAction;

const addUserToReadByForBriefspreadAction = thunkToAction(
  addUserToReadByForBriefspread.action
);
export type AddUserToReadByForBriefspreadType = typeof addUserToReadByForBriefspreadAction;

const addUserToReadByForCommentsAction = thunkToAction(
  addUserToReadByForComments.action
);
export type AddUserToReadByForCommentsType = typeof addUserToReadByForCommentsAction;



// WEBPACK FOOTER //
// ./src/commentView/actions.ts